<template>
  <div>
    <vs-card clas="w-full">
      <!-- Cabeçalho -->
      <div slot="header"><h3>Relatório</h3></div>

      <!-- Mensagem inicial -->
      <h6 v-if="relatorio.length == 0">
        Selecione as opções acima para gerar o seu relatório.
      </h6>

      <!-- Relatório Gerado -->
      <div v-else>
        <!-- Botões -->
        <div class="flex gap-2 justify-end my-3 flex-col lg:flex-row">
          <vs-button icon="star" color="warning" @click="abreModalFavoritos"
            >Salvar nos Favoritos
          </vs-button>
          <downloadexcel
            v-if="relatorio.length > 0"
            :data="relatorio"
            name="relatorio.xls"
            type="xls"
          >
            <vs-button class="w-full" color="dark" icon="file_download"
              >Download
            </vs-button>
          </downloadexcel>
        </div>

        <!-- Tabela -->
        <vs-table :data="relatorio" search stripe pagination max-items="20">
          <!-- Resumo -->
          <template slot="header">
            <div>
              <div v-if="relatorio.length > 0" class="m-3">
                {{ relatorio.length }}
                {{
                  relatorio.length == 1
                    ? 'registro encontrado'
                    : 'registros encontrados'
                }}
              </div>
            </div>
          </template>

          <!-- Colunas -->
          <template slot="thead">
            <vs-th v-for="(item, index) in colunas" :key="index">
              {{ item }}
            </vs-th>
          </template>

          <!-- Valores -->
          <template slot-scope="{ data }">
            <vs-tr
              :key="indexItemRelatorio"
              v-for="(itemRelatorio, indexItemRelatorio) in data"
            >
              <vs-td
                v-for="(item, index) in itemRelatorio"
                :key="index"
                :data="data[indexItemRelatorio]"
                >{{ item }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
  </div>
</template>
<script>
import downloadexcel from 'vue-json-excel';
import notify from '../../../../../utils/notify';

export default {
  props: ['relatorioGerado'],

  components: {
    downloadexcel,
  },

  data() {
    return {
      colunas: [],
      valores: [],
      relatorio: [],
    };
  },

  watch: {
    relatorioGerado(value) {
      if (value.length == 0) {
        notify.notifyFail(this.$vs, 'Não há resultados com essa consulta.');
        return;
      }
      this.relatorio = value;
      this.preparaTabela();
    },
  },

  methods: {
    abreModalFavoritos() {
      this.$emit('abreModalFavoritos', true);
    },

    preparaTabela() {
      this.colunas = Object.keys(this.relatorio[0]);

      this.relatorio.forEach((item) => {
        this.valores.push(Object.values(item));
      });
    },
  },
};
</script>
